import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import LanguageIcon from "@material-ui/icons/Language";
import { useTranslation } from "react-i18next";

const languages = ["uk", "ru", "en"];

const LanguageSwitcher = () => {
	const classes = useStyles();
	const { i18n, t } = useTranslation();
	const currentLanguage = i18n.language && i18n.language.split("-")[0];

	const handleChangeLanguage = (language) => {
		i18n.changeLanguage(language);
		localStorage.setItem("i18nextLng", language);
	};

	return (
		<div className={classes.root}>
			<LanguageIcon className={classes.icon} />
			<Typography className={classes.label}>{t("language.label")}</Typography>
			<FormControl className={classes.control} variant="outlined" size="small">
				<Select
					value={languages.includes(currentLanguage) ? currentLanguage : "uk"}
					onChange={(event) => handleChangeLanguage(event.target.value)}
					className={classes.select}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
				>
					{languages.map((language) => (
						<MenuItem key={language} value={language}>
							{t(`language.${language}`)}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
};

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		alignItems: "center",
		marginRight: 16,
		[theme.breakpoints.down("xs")]: {
			marginRight: 8,
		},
	},
	icon: {
		marginRight: 6,
		fontSize: 18,
		color: "#476282",
	},
	label: {
		marginRight: 8,
		fontSize: 13,
		color: "#476282",
		[theme.breakpoints.down("xs")]: {
			display: "none",
		},
	},
	control: {
		height: 32,
	},
	select: {
		height: 32,
		minWidth: 78,
		fontSize: 13,
		color: "#476282",
		backgroundColor: "#fff",
		"& .MuiSelect-select": {
			paddingTop: 7,
			paddingBottom: 7,
			paddingLeft: 10,
			paddingRight: 28,
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "#D3D9DD",
		},
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: "#326dff",
		},
		"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: "#326dff",
		},
	},
}));

export default LanguageSwitcher;
